<template>
  <v-card>
    <v-card-title class="group-title">
      <span v-if="!$vuetify.breakpoint.xsOnly"> Subscription Plan</span>
    </v-card-title>
    <v-card-text>
      <v-radio-group column v-model="subscription">
        <v-radio
          v-if="group.free_trail"
          active-class="active-radio-div"
          class="radio-div"
          value="free"
        >
          <template v-slot:label>
            <div>
              <div class="subs-dicsount blue--text mt-0">
                Start your FREE trial
              </div>
              <span class="subsciption-price">₹ 0</span>
              <span class="subs-dicsount"> For a week </span>
            </div>
          </template>
        </v-radio>
        <v-radio
          v-for="(item, id) in group.price"
          :key="id.item"
          active-class="active-radio-div"
          class="radio-div"
          :value="id"
          @change="() => handleSubscriptionChange(item)"
        >
          <template v-slot:label>
            <div>
              <span class="subsciption-price"
                >₹{{
                  item.is_discount_price_live ? item.discount_price : item.price
                }} </span
              ><span
                v-if="item.is_discount_price_live"
                class="subs-dicsount"
                style="text-decoration: line-through"
              >
                ₹{{ item.price }}</span
              >
              <span
                class="subs-dicsount"
                v-if="
                  item.plan === 'Monthly' ||
                  item.plan === 'Quarterly' ||
                  item.plan === 'Weekly' ||
                  item.plan === 'Yearly' ||
                  item.plan === 'Half Yearly'
                "
              >
                Per
                {{ item.plan.split(" ")[0].split("").slice(0, -2).join("") }}
              </span>
              <span class="subs-dicsount" v-if="item.plan === 'Daily'">
                Per Day
              </span>
            </div>
          </template>
        </v-radio>
      </v-radio-group>
      <div class="d-flex mb-4">
        <div class="coupon-icon"><v-img :src="coupon"> </v-img></div>
        <div class="apply-coupon-text" @click="openCouponField">
          Apply Coupon Code
        </div>
        <v-spacer></v-spacer>
        <div @click="onCloseCoupon">
          <v-icon v-if="toggleCouponField" style="cursor: pointer"
            >mdi-close-circle</v-icon
          >
        </div>
      </div>
      <div class="d-flex" v-if="toggleCouponField">
        <v-text-field
          placeholder="Enter code here"
          outlined
          class="pr-2"
          v-model="couponCode"
          @input="toggleApplyButton"
          hide-details
        ></v-text-field>

        <!-- <v-btn :disabled="!couponCode" x-large class="text-none py-7" color="primary" elevation="0">Apply</v-btn> -->

        <v-btn
          :disabled="!couponCode"
          elevation="0"
          x-large
          class="text-none py-7"
          :class="{ primary: couponCode && !isApplied, green: isApplied }"
          @click="applyCoupon()"
          style="color: white"
          >{{ isApplied ? "Applied" : "Apply" }}</v-btn
        >
      </div>
      <div class="red--text" v-if="toggleCouponField">{{ couponStatus }}</div>
      <div class="center-content" v-if="isApplied">
        <div class="verify-icon mx-auto mt-2">
          <v-img :src="verified_badge"> </v-img>
        </div>
        <div class="cong-text">Congratulations</div>
        <div>Coupon Applied Successfully</div>
        <div class="saved-text">Saved {{ discount_percentage }}%</div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-if="subscription === 'free'"
        @click="subscribeForFree()"
        class="subs-button"
        color="primary"
        :loading="loading"
        block
        >Subscribe for free</v-btn
      >
      <v-btn
        v-else
        @click="create_payment_order()"
        class="subs-button"
        color="primary"
        :loading="loading"
        block
        >Subscribe</v-btn
      >
    </v-card-actions>
    <PaymentModal></PaymentModal>
  </v-card>
</template>

<script>
import newAxios from "@/api/newAxios";
import { mapActions } from "vuex";
import Axios from "@/api/BaseAxios";
import apiUrl from "@/common/apiUrl";
import commonFunctions from "@/common/commonFunctions";
import PaymentModal from "@/components/Group/PaymentDetail/PaymentDetail.vue";

export default {
  props: {
    group: {
      type: Object,
      required: true,
    },
  },
  components: { PaymentModal },
  data() {
    return {
      subscription: 0,
      commonFun: commonFunctions,
      loading: false,
      payBtnLoader: false,
      order_detail: {},
      key_id: null,
      prefill: {},
      admin_id: null,
      patch_count: 0,
      coupon: require("@/assets/images/coupon.svg"),
      verified_badge: require("@/assets/images/verified_badge.svg"),
      toggleCouponField: false,
      couponCode: "",
      isApplied: false,
      couponStatus: "",
      discount_percentage: null,
      couponAppliedFlag: false,
      coupon_id: null,
    };
  },
  computed: {
    isPaymentHappening() {
      return (
        this.group.is_admin_payment_info &&
        this.group.admin_payment_info.verification_status === "Verified"
      );
    },
    detail() {
      let detail = {};
      detail["group_id"] = this.group.id;
      detail["plan"] = this.group.price[this.subscription].id;
      detail["user_id"] = this.commonFun.getUserId();
      return detail;
    },
  },
  watch: {
    subscription(newVal) {
      // Directly store the plan in localStorage when subscription changes
      const selectedPlan = this.group.price[newVal]?.plan;
      if (selectedPlan) {
        localStorage.setItem("selectedPlan", selectedPlan); // Store the selected plan
      }
    },
  },
  methods: {
    ...mapActions({
      togglePaymentDetail: "payment/togglePaymentDetail",
      snackBar: "snackBar/showSnack",
    }),
    handleSubscriptionChange(item) {
      this.$store.commit("subscription/SET_SUBSCRIPTION_VALUE", item.plan);
      console.log(item.plan, "202");
    },
    subscribe() {
      if (this.isPaymentHappening) {
        this.togglePaymentDetail({ show: true, detail: this.detail });
      } else {
        this.snackBar({
          text: "Payment Process is not active for this group yet",
          color: "warning",
          timeout: 2500,
        });
      }
    },

    create_payment_order() {
      this.loading = true;
      const successHandler = (res) => {
        console.log(res);
        this.duration = res.data.duration_detail;
        this.order_detail = res.data.order_detail;
        this.admin_id = this.order_detail.group_detail.admin.id;
        // console.log(this.admin_id);
        this.key_id = res.data.key_id;
        this.prefill = res.data.prefill;
        // this.loadImageComponent = true;
        this.loading = false;
        this.openPaymentGateway();
      };
      const failureHandler = () => {
        this.loading = false;
      };
      let formData = {};
      formData["group_id"] = this.group.id;
      formData["plan"] = this.group.price[this.subscription].id;
      formData["user_id"] = this.commonFun.getUserId();
      if (this.couponAppliedFlag == true) {
        formData["coupon"] = this.coupon_id;
      }
      Axios.request_POST_PARAMS(
        apiUrl.ORDER_PAYMENT,
        {},
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    openPaymentGateway() {
      const self = this;
      this.payBtnLoader = true;
      let total_price = this.order_detail.total_price * 100;
      let options = {
        key: this.key_id, // Enter the Key ID generated from the Dashboard
        amount: total_price, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
        currency: "INR",
        name: this.order_detail.group_detail.name,
        description: "Paid Membership",
        image: this.order_detail.group_detail.picture,
        order_id: this.order_detail.order_id,
        handler: function (response) {
          self.updatePaymentDetail(true, response);
          self.paymentSuccess = true;
          // this.$logEvent("premium_group");
          if (this.$vuetify.breakpoint.xsOnly) {
            this.$logEvent("mweb_premium_group");
          }
          if (this.admin_id == 99779) {
            this.$logEvent("covesting_technologies_group");

            if (this.$vuetify.breakpoint.xsOnly) {
              this.$logEvent("mweb_covesting_technologies_group");
            }
          }

          // alert(response.razorpay_payment_id);
          // alert(response.razorpay_order_id);
          // alert(response.razorpay_signature);
        },
        // callback_url: "http://localhost:8000/api/payment-webhook/",
        // prefill: {
        //   name: "Gaurav Kumar",
        //   email: "gaurav.kumar@example.com",
        //   contact: "9999999999",
        // },
        prefill: this.prefill,
        // notes: {
        //   address: "Razorpay Corporate Office",
        // },
        theme: {
          color: "#3399cc",
        },
      };
      var rzp1 = window.Razorpay(options);
      rzp1.on("payment.failed", function (response) {
        this.payBtnLoader = false;
        rzp1.close();
        this.$logEvent("premium_group_failed");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_premium_group_failed");
        }
        if (this.admin_id == 99779) {
          this.$logEvent("covesting_technologies_group_failed");

          if (this.$vuetify.breakpoint.xsOnly) {
            this.$logEvent("mweb_covesting_technologies_group_failed");
          }
        }

        // alert(response.error.code);
        // alert(response.error.description);
        // alert(response.error.source);
        // alert(response.error.step);
        // alert(response.error.reason);
        // alert(response.error.metadata.order_id);
        // alert(response.error.metadata.payment_id);
        self.snackBar({
          text: `failed : ${response.error.reason}, Payment ID: ${response.error.metadata.payment_id}`,
          color: "error",
          timeout: 2500,
        });
        self.updatePaymentDetail(false, response);
        // self.togglePaymentDetail({ show: false });
      });
      rzp1.open();
    },
    updatePaymentDetail(success, res) {
      const successHandler = () => {
        // this.count++;
        // if (this.count == 1) {
        this.$logEvent("premium_group");
        if (this.isApplied) {
          this.$logEvent("coupon_applied_and_group_subscribe");
        }
        // }
        // if (this.$vuetify.breakpoint.xsOnly) {
        //   this.$logEvent("mweb_premium_group");
        // }
        // console.log(this.admin_id);
        if (this.admin_id == 99779) {
          this.$logEvent("covesting_technologies_group");
          console.log("successfully enter in to covesting technologies group");
          if (this.$vuetify.breakpoint.xsOnly) {
            this.$logEvent("mweb_covesting_technologies_group");
          }
        }
        this.eventBus.$emit("refresh-group-detail");

        this.payBtnLoader = false;
      };
      const failureHandler = () => {
        this.payBtnLoader = false;
      };
      const finallyHandler = () => {
        if (success) {
          this.eventBus.$emit("refresh-group-detail");
        }
      };
      let formData = {};
      formData["id"] = this.order_detail.id;
      if (success) {
        formData["payment_id"] = res.razorpay_payment_id;
        formData["payment_signature"] = res.razorpay_signature;
        formData["payment_status"] = "successful";
        // const url = `${location.protocol}//${location.host}/groups/2145`;
        // window.open(url, "_self");
      } else {
        this.payBtnLoader = false;
        formData["payment_status"] = "failed";
      }
      Axios.request_PATCH(
        apiUrl.ORDER_PAYMENT,
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true,
        finallyHandler
      );
    },
    openCouponField() {
      this.toggleCouponField = true;
    },
    onCloseCoupon() {
      this.toggleCouponField = false;
      this.couponCode = "";
      this.couponStatus = "";
      this.isApplied = false;
    },
    toggleApplyButton() {
      this.isApplied = false;
      this.couponStatus = "";
    },
    applyCoupon() {
      const onSuccess = (res) => {
        if (res.data.message == "Valid Coupon") {
          this.isApplied = true;
          this.couponStatus = "";
          this.coupon_id = res.data.coupon_id;
          this.discount_percentage = res.data.discount_percentage;
          this.couponAppliedFlag = true;
        } else {
          this.couponStatus = res.data.message;
          this.isApplied = false;
        }
        this.$logEvent("coupon_applied");
      };
      const onFailure = () => {};
      let formData = {};
      formData["coupon_code"] = this.couponCode;
      formData["group"] = this.group.id;
      // formData["plan"] = this.group.price[this.subscription].id;
      newAxios("get", "/api/valid_coupon/", {
        onSuccess,
        onFailure,
        params: formData,
        isTokenRequired: true,
      });
    },
    subscribeForFree() {
      const onSuccess = () => {
        window.location.reload();
      };
      const onFailure = () => {};
      let data = new FormData();
      data.append("group", this.group.id);
      newAxios("post", apiUrl.SUBSCRIBE_FOR_FREE, {
        data,
        onSuccess,
        onFailure,
        isTokenRequired: true,
      });
    },
  },

  mounted() {},
};
</script>

<style lang="scss" scoped>
.radio-div {
  padding: 17px !important;
  border: 1px solid #dddddd;
  border-radius: 4px;
  //   margin-bottom: 5px;
}

::v-deep.active-radio-div {
  background-color: #edf5ff !important;
}

.subs-button {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 100;
  line-height: 27.32px;
  text-align: center;
  height: 50px !important;
  border-radius: 4px;
  text-transform: capitalize;
}

.subs-dicsount {
  font-family: Avenir;
  font-size: 14px;
  font-weight: 500;
  line-height: 19.12px;
  text-align: left;
  color: #333333ad;
}

.subsciption-price {
  font-family: Avenir;
  font-size: 25px;
  font-weight: 800;
  line-height: 34.15px;
  text-align: left;
  color: #333333;
}

.group-title {
  font-family: Avenir;
  font-size: 19px;
  font-weight: 800;
  line-height: 27.32px;
  text-align: left;
  color: #333333;
}

.coupon-icon {
  width: 24px;
  height: 24px;
  // margin-left: auto;
  margin-right: 10px;
  // margin-top: 8px;
}

.apply-coupon-text {
  font-family: Avenir;
  font-size: 18px;
  font-weight: 500;
  line-height: 24.59px;
  color: #2d8cff;
  cursor: pointer;
}

.verify-icon {
  width: 54px;
  height: 54px;
}

.center-content {
  text-align: center;
  margin: 0 auto;
}

.cong-text {
  font-size: 18px;
  font-weight: 500;
  line-height: 24.59px;
}

.saved-text {
  font-size: 20px;
  line-height: 27.32px;
  color: #27ae60;
}
</style>
